import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";

export enum Outcomes {
  yes = "Yes",
  no = "No",
  notSure = "I'm not sure",
}

interface Props {
  notDeceased?: boolean;
}

export const VeteranScreen = ({ notDeceased }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  let title = `Was ${activeEstate?.deceasedFirstName} a veteran?`;
  if (notDeceased) {
    title = `Is ${activeEstate?.deceasedFirstName} a veteran?`;
  }

  const handleComplete = async (wasVeteran: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    const estate = activeEstate || new Estate();
    estate.wasVeteran = wasVeteran;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, wasVeteran, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title={title}>
      <RadioAndResponseForm
        initAnswer={activeEstate?.wasVeteran}
        answerLabel="DeceasedVeteranStatus"
        errorText={`Oops! Please tell us if ${activeEstate?.deceasedFirstName} was a veteran.`}
        options={[
          { value: Outcomes.yes },
          { value: Outcomes.no },
          { value: Outcomes.notSure },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
